export default __webpack_public_path__ + "static/media/choc.03ac70bb.jpg";